export default __webpack_public_path__ + "img/fb_icon.542703d3.svg";